module.exports = __webpack_public_path__ + "img/ic-favorite-bw.6ff9c5aa.svg";